const contacts = [
  {
    text: 'Linkedin',
    url: 'https://www.linkedin.com/in/renata-p-nunes/',
  },
  {
    text: 'GitHub',
    url: 'https://github.com/renatapnunes',
  },
  {
    text: 'Currículo',
    url: 'https://github.com/renatapnunes/portfolio/blob/main/RenataNunes_curriculo.pdf',
  },
];

export default contacts;
